export interface CountryCode {
    code: string,
    icon: string,
    name: {
        zh: string
        en: string
        es: string
        ja: string
        vi: string
        pt: string
    }
}
export const countryCode: CountryCode[] = [
    {
        "code": "+86",
        "icon": "🇨🇳",
        "name": {
            "zh": "中国",
            "en": "China (Mainland)",
            "es": "China continental",
            "ja": "中国本土",
            "vi": "Trung Quốc đại lục",
            "pt": "China Continental"
        }
    },
    {
        "code": "+852",
        "icon": "🇭🇰",
        "name": {
            "zh": "中国香港",
            "en": "Hong Kong, China",
            "es": "Hong Kong, China",
            "ja": "中国香港",
            "vi": "Hồng Kông, Trung Quốc",
            "pt": "Hong Kong, China"
        }
    },
    {
        "code": "+853",
        "icon": "🇲🇴",
        "name": {
            "zh": "中国澳门",
            "en": "Macau, China",
            "es": "Macao, China",
            "ja": "中国マカオ",
            "vi": "Macao, Trung Quốc",
            "pt": "Macau, China"
        }
    },
    {
        "code": "+886",
        "icon": "🇹🇼",
        "name": {
            "zh": "中国台湾",
            "en": "Taiwan, China",
            "es": "Taiwán, China",
            "ja": "中国台湾",
            "vi": "Đài Loan, Trung Quốc",
            "pt": "Taiwan, China"
        }
    },
    {
        "code": "+65",
        "icon": "🇸🇬",
        "name": {
            "zh": "新加坡",
            "en": "Singapore",
            "es": "Singapur",
            "ja": "シンガポール",
            "vi": "Singapore",
            "pt": "Singapura"
        }
    },
    {
        "icon": "🇦🇫",
        "code": "+93",
        "name": {
            "zh": "阿富汗",
            "en": "Afghanistan",
            "es": "Afganistán",
            "ja": "アフガニスタン",
            "vi": "Afghanistan",
            "pt": "Afeganistão"
        }
    },
    {
        "icon": "🇦🇱",
        "code": "+355",
        "name": {
            "zh": "阿尔巴尼亚",
            "en": "Albania",
            "es": "Albania",
            "ja": "アルバニア",
            "vi": "Albani",
            "pt": "Albânia"
        }
    },
    {
        "icon": "🇩🇿",
        "code": "+213",
        "name": {
            "zh": "阿尔及利亚", 
            "en": "Algeria",
            "es": "Argelia",
            "ja": "アルジェリア",
            "vi": "Algérie",
            "pt": "Argélia"
        }
    },
    {
        "icon": "🇦🇩",
        "code": "+376",
        "name": {
            "zh": "安道尔",
            "en": "Andorra",
            "es": "Andorra",
            "ja": "アンドラ",
            "vi": "Andorra",
            "pt": "Andorra"
        }
    },

    {
        "icon": "🇦🇴",
        "code": "+244",
        "name": {
            "zh": "安哥拉",
            "en": "Angola",
            "es": "Angola",
            "ja": "アンゴラ",
            "vi": "Angola",
            "pt": "Angola"
        }
    },
    {
        "icon": "🇦🇮",
        "code": "+1264",
        "name": {
            "zh": "安圭拉",
            "en": "Anguilla",
            "es": "Anguila",
            "ja": "アンギラ",
            "vi": "Anguilla",
            "pt": "Anguilla"
        }
    },
    {
        "icon": "🇦🇨",
        "code": "+247",
        "name": {
            "zh": "阿森松岛",
            "en": "Ascension Island",
            "es": "Isla Ascensión",
            "ja": "アセンション島",
            "vi": "Đảo Ascension",
            "pt": "Ilha de Ascensão"
        }
    },
    {
        "icon": "🇦🇬",
        "code": "+1268",
        "name": {
            "zh": "安提瓜和巴布达",
            "en": "Antigua and Barbuda",
            "es": "Antigua y Barbuda",
            "ja": "アンティグア・バーブーダ",
            "vi": "Antigua và Barbuda",
            "pt": "Antígua e Barbuda"
        }
    },
    {
        "icon": "🇦🇷",
        "code": "+54",
        "name": {
            "zh": "阿根廷",
            "en": "Argentina",
            "es": "Argentina",
            "ja": "アルゼンチン",
            "vi": "Argentina",
            "pt": "Argentina"
        }
    },
    {
        "icon": "🇦🇲",
        "code": "+374",
        "name": {
            "zh": "亚美尼亚",
            "en": "Armenia",
            "es": "Armenia",
            "ja": "アルメニア",
            "vi": "Armenia",
            "pt": "Arménia"
        }
    },
    {
        "icon": "🇦🇼",
        "code": "+297",
        "name": {
            "zh": "阿鲁巴",
            "en": "Aruba",
            "es": "Aruba",
            "ja": "アルバ",
            "vi": "Aruba",
            "pt": "Aruba"
        }
    },
    {
        "icon": "🇦🇺",
        "code": "+61",
        "name": {
            "zh": "澳大利亚",
            "en": "Australia",
            "es": "Australia",
            "ja": "オーストラリア",
            "vi": "Úc",
            "pt": "Austrália"
        }
    },
    {
        "icon": "🇦🇹",
        "code": "+43",
        "name": {
            "zh": "奥地利",
            "en": "Austria",
            "es": "Austria",
            "ja": "オーストリア",
            "vi": "Áo",
            "pt": "Áustria"
        }
    },
    {
        "icon": "🇦🇿",
        "code": "+994",
        "name": {
            "zh": "阿塞拜疆",
            "en": "Azerbaijan",
            "es": "Azerbaiyán",
            "ja": "アゼルバイジャン",
            "vi": "Azerbaijan",
            "pt": "Azerbaijão"
        }
    },
    {
        "icon": "🇧🇸",
        "code": "+1242",
        "name": {
            "zh": "巴哈马",
            "en": "Bahamas",
            "es": "Bahamas",
            "ja": "バハマ",
            "vi": "Bahamas",
            "pt": "Bahamas"
        }
    },
    {
        "icon": "🇧🇭",
        "code": "+973",
        "name": {
            "zh": "巴林",
            "en": "Bahrain",
            "es": "Baréin",
            "ja": "バーレーン",
            "vi": "Bahrain",
            "pt": "Bahrein"
        }
    },
    {
        "icon": "🇧🇩",
        "code": "+880",
        "name": {
            "zh": "孟加拉国",
            "en": "Bangladesh",
            "es": "Bangladés",
            "ja": "バングラデシュ",
            "vi": "Bangladesh",
            "pt": "Bangladesh"
        }
    },
    {
        "icon": "🇧🇧",
        "code": "+1246",
        "name": {
            "zh": "巴巴多斯",
            "en": "Barbados",
            "es": "Barbados",
            "ja": "バルバドス",
            "vi": "Barbados",
            "pt": "Barbados"
        }
    },
    {
        "icon": "🇧🇾",
        "code": "+375",
        "name": {
            "zh": "白俄罗斯",
            "en": "Belarus",
            "es": "Bielorrusia",
            "ja": "ベラルーシ",
            "vi": "Belarus",
            "pt": "Bielorrússia"
        }
    }
    ,
    {
        "icon": "🇧🇪",
        "code": "+32",
        "name": {
            "zh": "比利时",
            "en": "Belgium",
            "es": "Bélgica",
            "ja": "ベルギー",
            "vi": "Bỉ",
            "pt": "Bélgica"
        }
    },
    {
        "icon": "🇧🇿",
        "code": "+501",
        "name": {
            "zh": "伯利兹",
            "en": "Belize",
            "es": "Belice",
            "ja": "ベリーズ",
            "vi": "Belize",
            "pt": "Belize"
        }
    },
    {
        "icon": "🇧🇯",
        "code": "+229",
        "name": {
            "zh": "贝宁",
            "en": "Benin",
            "es": "Benín",
            "ja": "ベナン",
            "vi": "Bénin",
            "pt": "Benin"
        }
    },
    {
        "icon": "🇧🇲",
        "code": "+1441",
        "name": {
            "zh": "百慕大",
            "en": "Bermuda",
            "es": "Bermudas",
            "ja": "バミューダ",
            "vi": "Bermuda",
            "pt": "Bermudas"
        }
    },
    {
        "icon": "🇧🇹",
        "code": "+975",
        "name": {
            "zh": "不丹",
            "en": "Bhutan",
            "es": "Bután",
            "ja": "ブータン",
            "vi": "Bhutan",
            "pt": "Butão"
        }
    },
    {
        "icon": "🇧🇴",
        "code": "+591",
        "name": {
            "zh": "玻利维亚",
            "en": "Bolivia",
            "es": "Bolivia",
            "ja": "ボリビア",
            "vi": "Bolivia",
            "pt": "Bolívia"
        }
    },
    {
        "icon": "🇧🇦",
        "code": "+387",
        "name": {
            "zh": "波斯尼亚和黑塞哥维那",
            "en": "Bosnia and Herzegovina",
            "es": "Bosnia y Herzegovina",
            "ja": "ボスニア・ヘルツェゴビナ",
            "vi": "Bosnia và Herzegovina",
            "pt": "Bósnia e Herzegovina"
        }
    },
    {
        "icon": "🇧🇼",
        "code": "+267",
        "name": {
            "zh": "博茨瓦纳",
            "en": "Botswana",
            "es": "Botsuana",
            "ja": "ボツワナ",
            "vi": "Botswana",
            "pt": "Botsuana"
        }
    },
    {
        "code": "+55",
        "icon":"🇧🇷",
        "name": {
            "zh": "巴西",
            "en": "Brazil",
            "es": "Brasil",
            "ja": "ブラジル",
            "vi": "Brazil",
            "pt": "Brasil"
        }
    },
    {
        "icon": "🇧🇳",
        "code": "+673",
        "name": {
            "zh": "文莱",
            "en": "Brunei",
            "es": "Brunéi",
            "ja": "ブルネイ",
            "vi": "Brunei",
            "pt": "Brunei"
        }
    },
    {
        "icon": "🇧🇬",
        "code": "+359",
        "name": {
            "zh": "保加利亚",
            "en": "Bulgaria",
            "es": "Bulgaria",
            "ja": "ブルガリア",
            "vi": "Bulgaria",
            "pt": "Bulgária"
        }
    },
    {
        "icon": "🇧🇫",
        "code": "+226",
        "name": {
            "zh": "布基纳法索",
            "en": "Burkina Faso",
            "es": "Burkina Faso",
            "ja": "ブルキナファソ",
            "vi": "Burkina Faso",
            "pt": "Burquina Faso"
        }
    },
    {
        "icon": "🇧🇮",
        "code": "+257",
        "name": {
            "zh": "布隆迪",
            "en": "Burundi",
            "es": "Burundi",
            "ja": "ブルンジ",
            "vi": "Burundi",
            "pt": "Burundi"
        }
    },
    {
        "icon": "🇰🇭",
        "code": "+855",
        "name": {
            "zh": "柬埔寨",
            "en": "Cambodia",
            "es": "Camboya",
            "ja": "カンボジア",
            "vi": "Campuchia",
            "pt": "Camboja"
        }
    },
    {
        "icon": "🇨🇲",
        "code": "+237",
        "name": {
            "zh": "喀麦隆",
            "en": "Cameroon",
            "es": "Camerún",
            "ja": "カメルーン",
            "vi": "Cameroon",
            "pt": "Camarões"
        }
    },
    {
        "icon": "🇨🇦",
        "code": "+1",
        "name": {
            "zh": "加拿大",
            "en": "Canada",
            "es": "Canadá",
            "ja": "カナダ",
            "vi": "Canada",
            "pt": "Canadá"
        }
    },
    {
        "icon": "🇨🇻",
        "code": "+238",
        "name": {
            "zh": "佛得角",
            "en": "Cape Verde",
            "es": "Cabo Verde",
            "ja": "カーボベルデ",
            "vi": "Cabo Verde",
            "pt": "Cabo Verde"
        }
    },
    {
        "icon": "🇰🇾",
        "code": "+1345",
        "name": {
            "zh": "开曼群岛",
            "en": "Cayman Islands",
            "es": "Islas Caimán",
            "ja": "ケイマン諸島",
            "vi": "Quần đảo Cayman",
            "pt": "Ilhas Cayman"
        }
    },
    {
        "icon": "🇨🇫",
        "code": "+236",
        "name": {
            "zh": "中非共和国",
            "en": "Central African Republic",
            "es": "República Centroafricana",
            "ja": "中央アフリカ共和国",
            "vi": "Cộng hòa Trung Phi",
            "pt": "República Centro-Africana"
        }
    },
    {
        "icon": "🇹🇩",
        "code": "+235",
        "name": {
            "zh": "乍得",
            "en": "Chad",
            "es": "Chad",
            "ja": "チャド",
            "vi": "Tchad",
            "pt": "Chade"
        }
    },
    {
        "icon": "🇨🇱",
        "code": "+56",
        "name": {
            "zh": "智利",
            "en": "Chile",
            "es": "Chile",
            "ja": "チリ",
            "vi": "Chile",
            "pt": "Chile"
        }
    },
    {
        "icon": "🇨🇴",
        "code": "+57",
        "name": {
            "zh": "哥伦比亚",
            "en": "Colombia",
            "es": "Colombia",
            "ja": "コロンビア",
            "vi": "Colombia",
            "pt": "Colômbia"
        }
    },
    {
        "icon": "🇰🇲",
        "code": "+269",
        "name": {
            "zh": "科摩罗",
            "en": "Comoros",
            "es": "Comoras",
            "ja": "コモロ",
            "vi": "Comoros",
            "pt": "Comores"
        }
    },
    {
        "icon": "🇨🇬",
        "code": "+242",
        "name": {
            "zh": "刚果共和国",
            "en": "Republic of the Congo",
            "es": "República del Congo",
            "ja": "コンゴ共和国",
            "vi": "Cộng hòa Congo",
            "pt": "República do Congo"
        }
    },
    {
        "icon": "🇨🇩",
        "code": "+243",
        "name": {
            "zh": "刚果民主共和国",
            "en": "Democratic Republic of the Congo",
            "es": "República Democrática del Congo",
            "ja": "コンゴ民主共和国",
            "vi": "Cộng hòa Dân chủ Congo",
            "pt": "República Democrática do Congo"
        }
    },
    {
        "icon": "🇨🇰",
        "code": "+682",
        "name": {
            "zh": "库克群岛",
            "en": "Cook Islands",
            "es": "Islas Cook",
            "ja": "クック諸島",
            "vi": "Quần đảo Cook",
            "pt": "Ilhas Cook"
        }
    },
    {
        "icon": "🇨🇷",
        "code": "+506",
        "name": {
            "zh": "哥斯达黎加",
            "en": "Costa Rica",
            "es": "Costa Rica",
            "ja": "コスタリカ",
            "vi": "Costa Rica",
            "pt": "Costa Rica"
        }
    },
    {
        "icon": "🇨🇮",
        "code": "+225",
        "name": {
            "zh": "科特迪瓦",
            "en": "Côte d'Ivoire",
            "es": "Costa de Marfil",
            "ja": "コートジボワール",
            "vi": "Bờ Biển Ngà",
            "pt": "Costa do Marfim"
        }
    },
    {
        "icon": "🇭🇷",
        "code": "+385",
        "name": {
            "zh": "克罗地亚",
            "en": "Croatia",
            "es": "Croacia",
            "ja": "クロアチア",
            "vi": "Croatia",
            "pt": "Croácia"
        }
    },
    {
        "icon": "🇨🇺",
        "code": "+53",
        "name": {
            "zh": "古巴",
            "en": "Cuba",
            "es": "Cuba",
            "ja": "キューバ",
            "vi": "Cuba",
            "pt": "Cuba"
        }
    },
    {
        "icon": "🇨🇾",
        "code": "+357",
        "name": {
            "zh": "塞浦路斯",
            "en": "Cyprus",
            "es": "Chipre",
            "ja": "キプロス",
            "vi": "Síp",
            "pt": "Chipre"
        }
    },
    {
        "icon": "🇨🇿",
        "code": "+420",
        "name": {
            "zh": "捷克共和国",
            "en": "Czech Republic",
            "es": "República Checa",
            "ja": "チェコ共和国",
            "vi": "Cộng hòa Séc",
            "pt": "República Tcheca"
        }
    },
    {
        "code": "+45",
        "icon": "🇩🇰",
        "name": {
            "zh": "丹麦",
            "en": "Denmark",
            "es": "Dinamarca",
            "ja": "デンマーク",
            "vi": "Đan Mạch",
            "pt": "Dinamarca"
        }
    },
    {
        "icon": "🇩🇯",
        "code": "+253",
        "name": {
            "zh": "吉布提",
            "en": "Djibouti",
            "es": "Yibuti",
            "ja": "ジブチ",
            "vi": "Djibouti",
            "pt": "Djibuti"
        }
    },
    {
        "icon": "🇩🇲",
        "code": "+1767",
        "name": {
            "zh": "多米尼克",
            "en": "Dominica",
            "es": "Dominica",
            "ja": "ドミニカ国",
            "vi": "Dominica",
            "pt": "Dominica"
        }
    },
    {
        "icon": "🇩🇴",
        "code": "+1809",
        "name": {
            "zh": "多米尼加共和国",
            "en": "Dominican Republic",
            "es": "República Dominicana",
            "ja": "ドミニカ共和国",
            "vi": "Cộng hòa Dominica",
            "pt": "República Dominicana"
        }
    },
    {
        "icon": "🇪🇨",
        "code": "+593",
        "name": {
            "zh": "厄瓜多尔",
            "en": "Ecuador",
            "es": "Ecuador",
            "ja": "エクアドル",
            "vi": "Ecuador",
            "pt": "Equador"
        }
    },
    {
        "icon": "🇪🇬",
        "code": "+20",
        "name": {
            "zh": "埃及",
            "en": "Egypt",
            "es": "Egipto",
            "ja": "エジプト",
            "vi": "Ai Cập",
            "pt": "Egito"
        }
    },
    {
        "icon": "🇸🇻",
        "code": "+503",
        "name": {
            "zh": "萨尔瓦多",  
            "en": "El Salvador",
            "es": "El Salvador",
            "ja": "エルサルバドル",
            "vi": "El Salvador",
            "pt": "El Salvador"
        }
    },
    {
        "icon": "🇪🇪",
        "code": "+372",
        "name": {
            "zh": "爱沙尼亚",
            "en": "Estonia",
            "es": "Estonia",
            "ja": "エストニア",
            "vi": "Estonia",
            "pt": "Estónia"
        }
    },
    {
        "icon": "🇪🇹",
        "code": "+251",
        "name": {
            "zh": "埃塞俄比亚",
            "en": "Ethiopia",
            "es": "Etiopía",
            "ja": "エチオピア",
            "vi": "Ethiopia",
            "pt": "Etiópia"
        }
    },
    {
        "icon": "🇫🇴",
        "code": "+298",
        "name": {
            "zh": "法罗群岛",
            "en": "Faroe Islands",
            "es": "Islas Feroe",
            "ja": "フェロー諸島",
            "vi": "Quần đảo Faroe",
            "pt": "Ilhas Faroé",
        }
    },
    {
        "icon": "🇫🇯",
        "code": "+679",
        "name": {
            "zh": "斐济",
            "en": "Fiji",
            "es": "Fiyi",
            "ja": "フィジー",
            "vi": "Fiji",
            "pt": "Fiji"
        }
    },
    {
        "icon": "🇫🇮",
        "code": "+358",
        "name": {
            "zh": "芬兰",
            "en": "Finland",
            "es": "Finlandia",
            "ja": "フィンランド",
            "vi": "Phần Lan",
            "pt": "Finlândia"
        }
    },
    {
        "icon": "🇫🇷",
        "code": "+33",
        "name": {
            "zh": "法国",
            "en": "France",
            "es": "Francia",
            "ja": "フランス",
            "vi": "Pháp",
            "pt": "França"
        }
    },
    {
        "icon": "🇬🇫",
        "code": "+594",
        "name": {
            "zh": "法属圭亚那",
            "en": "French Guiana",
            "es": "Guayana Francesa",
            "ja": "フランス領ギアナ",
            "vi": "Guiana thuộc Pháp",
            "pt": "Guiana Francesa",
        }
    },
    {
        "icon": "🇵🇫",
        "code": "+689",
        "name": {
            "zh": "法属波利尼西亚",
            "en": "French Polynesia",
            "es": "Polinesia Francesa",
            "ja": "フランス領ポリネシア",
            "vi": "Polynésie thuộc Pháp",
            "pt": "Polinésia Francesa",
        }
    },
    {
        "icon": "🇬🇦",
        "code": "+241",
        "name": {
            "zh": "加蓬",
            "en": "Gabon",
            "es": "Gabón",
            "ja": "ガボン",
            "vi": "Gabon",
            "pt": "Gabão"
        }
    },
    {
        "icon": "🇬🇲",
        "code": "+220",
        "name": {
            "zh": "冈比亚",
            "en": "The Gambia",
            "es": "Gambia",
            "ja": "ガンビア",
            "vi": "Gambia",
            "pt": "Gâmbia"
        }
    },
    {
        "icon": "🇬🇪",
        "code": "+995",
        "name": {
            "zh": "格鲁吉亚",
            "en": "Georgia",
            "es": "Georgia",
            "ja": "ジョージア",
            "vi": "Gruzia",
            "pt": "Geórgia"
        }
    },
    {
        "icon": "🇩🇪",
        "code": "+49",  
        "name": {
            "zh": "德国",
            "en": "Germany",
            "es": "Alemania",
            "ja": "ドイツ",
            "vi": "Đức",
            "pt": "Alemanha"
        }
    },
    {
        "icon": "🇬🇭",
        "code": "+233",
        "name": {
            "zh": "加纳",
            "en": "Ghana",
            "es": "Ghana",
            "ja": "ガーナ",
            "vi": "Ghana",
            "pt": "Gana"
        }
    },
    {
        "icon": "🇬🇮",
        "code": "+350",
        "name": {
            "zh": "直布罗陀",
            "en": "Gibraltar",
            "es": "Gibraltar",
            "ja": "ジブラルタル",
            "vi": "Gibraltar",
            "pt": "Gibraltar",
        }
    },
    {
        "code": "+30",
        "icon": "🇬🇷",
        "name": {
            "zh": "希腊",
            "en": "Greece",
            "es": "Grecia",
            "ja": "ギリシャ",
            "vi": "Hy Lạp",
            "pt": "Grécia"
        }
    },
    {
        "icon": "🇬🇱",
        "code": "+299",
        "name": {
            "zh": "格陵兰",
            "en": "Greenland",
            "es": "Groenlandia",
            "ja": "グリーンランド",
            "vi": "Greenland",
            "pt": "Gronelândia",
        }
    },
    {
        "icon": "🇬🇩",
        "code": "+1473",
        "name": {
            "zh": "格林纳达",
            "en": "Grenada",
            "es": "Granada",
            "ja": "グレナダ",
            "vi": "Grenada",
            "pt": "Granada"
        }
    },
    {
        "icon": "🇬🇵",
        "code": "+590",
        "name": {
            "zh": "瓜德罗普",
            "en": "Guadeloupe",
            "es": "Guadalupe",
            "ja": "グアドループ",
            "vi": "Guadeloupe",
            "pt": "Guadalupe",
        }
    },
    {
        "icon": "🇬🇺",
        "code": "+1671",
        "name": {
            "zh": "关岛",
            "en": "Guam",
            "es": "Guam",
            "ja": "グアム",
            "vi": "Guam",
            "pt": "Guam",
        }
    },
    {
        "icon": "🇬🇹",
        "code": "+502",
        "name": {
            "zh": "危地马拉",
            "en": "Guatemala",
            "es": "Guatemala",
            "ja": "グアテマラ",
            "vi": "Guatemala",
            "pt": "Guatemala"
        }
    },
    {
        "icon": "🇬🇶",
        "code": "+240",
        "name": {
            "zh": "赤道几内亚",
            "en": "Equatorial Guinea",
            "es": "Guinea Ecuatorial",
            "ja": "赤道ギニア",
            "vi": "Guinea Xích Đạo",
            "pt": "Guiné Equatorial"
        }
    },
    {
        "icon": "🇬🇬",
        "code": "+44",
        "name": {
            "zh": "根西",
            "en": "Guernsey",
            "es": "Guernsey",
            "ja": "ガーンジー",
            "vi": "Guernsey",
            "pt": "Guernsey",
        }
    },
    {
        "icon": "🇬🇳",
        "code": "+224",
        "name": {
            "zh": "几内亚",
            "en": "Guinea",
            "es": "Guinea",
            "ja": "ギニア",
            "vi": "Guinée",
            "pt": "Guiné"
        }
    },
    {
        "icon": "🇬🇾",
        "code": "+592",
        "name": {
            "zh": "圭亚那",
            "en": "Guyana",
            "es": "Guyana",
            "ja": "ガイアナ",
            "vi": "Guyana",
            "pt": "Guiana"
        }
    },
    {
        "icon": "🇭🇹",
        "code": "+509",
        "name": {
            "zh": "海地",
            "en": "Haiti",
            "es": "Haití",
            "ja": "ハイチ",
            "vi": "Haiti",
            "pt": "Haiti"
        }
    }
    ,
    {
        "icon": "🇭🇳",
        "code": "+504",
        "name": {
            "zh": "洪都拉斯",
            "en": "Honduras",
            "es": "Honduras",
            "ja": "ホンジュラス",
            "vi": "Honduras",
            "pt": "Honduras"
        }
    },
    {
        "icon": "🇲🇲",
        "code": "+95",
        "name": {
            "zh": "缅甸",
            "en": "Myanmar",
            "es": "Myanmar",
            "ja": "ミャンマー",
            "vi": "Myanmar",
            "pt": "Mianmar"
        }
    },
    {
        "icon": "🇭🇺",
        "code": "+36",
        "name": {
            "zh": "匈牙利",
            "en": "Hungary",
            "es": "Hungría",
            "ja": "ハンガリー",
            "vi": "Hungary",
            "pt": "Hungria"
        }
    },
    {
        "icon": "🇮🇸",
        "code": "+354",
        "name": {
            "zh": "冰岛",
            "en": "Iceland",
            "es": "Islandia",
            "ja": "アイスランド",
            "vi": "Iceland",
            "pt": "Islândia"
        }
    },
    {
        "icon": "🇮🇳",
        "code": "+91",
        "name": {
            "zh": "印度",
            "en": "India",
            "es": "India",
            "ja": "インド",
            "vi": "Ấn Độ",
            "pt": "Índia"
        }
    },
    {
        "code": "+62",
        "icon":"🇮🇩",
        "name": {
            "zh": "印度尼西亚",
            "en": "Indonesia",
            "es": "Indonesia",
            "ja": "インドネシア",
            "vi": "Indonesia",
            "pt": "Indonésia"
        }
    },
    {
        "code": "+98",
        "icon":"🇮🇷",
        "name": {
            "zh": "伊朗",
            "en": "Iran",
            "es": "Irán",
            "ja": "イラン",
            "vi": "Iran",
            "pt": "Irã"
        }
    },
    {
        "code": "+964",
        "icon":"🇮🇶",
        "name": {
            "zh": "伊拉克",
            "en": "Iraq",
            "es": "Irak",
            "ja": "イラク",
            "vi": "Iraq",
            "pt": "Iraque"
        }
    },
    {
        "code": "+353",
        "icon": "🇮🇪",
        "name": {
            "zh": "爱尔兰",
            "en": "Ireland",
            "es": "Irlanda",
            "ja": "アイルランド",
            "vi": "Ireland",
            "pt": "Irlanda"
        }
    },
    {
        "code": "+44",
        "icon": "🇮🇲",
        "name": {
            "zh": "马恩岛",
            "en": "Isle of Man",
            "es": "Isla de Man",
            "ja": "マン島",
            "vi": "Đảo Man",
            "pt": "Ilha de Man",
        }
    },
    {
        "code": "+972",
        "icon": "🇮🇱",
        "name": {
            "zh": "以色列",
            "en": "Israel",
            "es": "Israel",
            "ja": "イスラエル",
            "vi": "Israel",
            "pt": "Israel"
        }
    },
    {
        "code": "+39",
        "icon": "🇮🇹",
        "name": {
            "zh": "意大利",
            "en": "Italy",
            "es": "Italia",
            "ja": "イタリア",
            "vi": "Ý",
            "pt": "Itália"
        }
    },
    {
        "icon": "🇯🇲",
        "code": "+1876",
        "name": {
            "zh": "牙买加",
            "en": "Jamaica",
            "es": "Jamaica",
            "ja": "ジャマイカ",
            "vi": "Jamaica",
            "pt": "Jamaica"
        }
    },
    {
        "code": "+81",
        "icon": "🇯🇵",
        "name": {
            "zh": "日本",
            "en": "Japan",
            "es": "Japón",
            "ja": "日本",
            "vi": "Nhật Bản",
            "pt": "Japão"
        }
    },
    {
        "icon": "🇯🇪",
        "code": "+44",
        "name": {
            "zh": "泽西岛",
            "en": "Jersey",
            "es": "Jersey",
            "ja": "ジャージー",
            "vi": "Jersey",
            "pt": "Jersey",
        }
    },
    {
        "icon": "🇯🇴",
        "code": "+962",
        "name": {
            "zh": "约旦",
            "en": "Jordan",
            "es": "Jordania",
            "ja": "ヨルダン",
            "vi": "Jordan",
            "pt": "Jordânia"
        }
    },
    {
        "code": "+7",
        "icon": "🇰🇿",
        "name": {
            "zh": "哈萨克斯坦",
            "en": "Kazakhstan",
            "es": "Kazajistán",
            "ja": "カザフスタン",
            "vi": "Kazakhstan",
            "pt": "Cazaquistão",
        }
    },
    {
        "code": "+254",
        "icon": "🇰🇪",
        "name": {
            "zh": "肯尼亚",
            "en": "Kenya",
            "es": "Kenia",
            "ja": "ケニア",
            "vi": "Kenya",
            "pt": "Quênia"
        }
    },
    {
        "code": "+383",
        "icon": "🇽🇰",
        "name": {
            "zh": "科索沃",
            "en": "Kosovo",
            "es": "Kosovo",
            "ja": "コソボ",
            "vi": "Kosovo",
            "pt": "Kosovo",
        }
    },
    {
        "code": "+965",
        "icon": "🇰🇼",
        "name": {
            "zh": "科威特",
            "en": "Kuwait",
            "es": "Kuwait",
            "ja": "クウェート",
            "vi": "Kuwait",
            "pt": "Kuwait"
        }
    },
    {
        "code": "+996",
        "icon": "🇰🇬",
        "name": {
            "zh": "吉尔吉斯斯坦",
            "en": "Kyrgyzstan",
            "es": "Kirguistán",
            "ja": "キルギス",
            "vi": "Kyrgyzstan",
            "pt": "Quirguistão"
        }
    },
    {
        "code": "+856",
        "icon": "🇱🇦",
        "name": {
            "zh": "老挝",
            "en": "Laos",
            "es": "Laos",
            "ja": "ラオス",
            "vi": "Lào",
            "pt": "Laos"
        }
    },
    {
        "code": "+371",
        "icon": "🇱🇻",
        "name": {
            "zh": "拉脱维亚",
            "en": "Latvia",
            "es": "Letonia",
            "ja": "ラトビア",
            "vi": "Latvia",
            "pt": "Letônia"
        }
    },
    {
        "code": "+961",
        "icon": "🇱🇧",
        "name": {
            "zh": "黎巴嫩",
            "en": "Lebanon",
            "es": "Líbano",
            "ja": "レバノン",
            "vi": "Lebanon",
            "pt": "Líbano"
        }
    },
    {
        "code": "+266",
        "icon": "🇱🇸",
        "name": {
            "zh": "莱索托",
            "en": "Lesotho",
            "es": "Lesoto",
            "ja": "レソト",
            "vi": "Lesotho",
            "pt": "Lesoto"
        }
    },
    {
        "code": "+231",
        "icon": "🇱🇷",
        "name": {
            "zh": "利比里亚",
            "en": "Liberia",
            "es": "Liberia",
            "ja": "リベリア",
            "vi": "Liberia",
            "pt": "Libéria"
        }
    },
    {
        "code": "+218",
        "icon": "🇱🇾",
        "name": {
            "zh": "利比亚",
            "en": "Libya",
            "es": "Libia",
            "ja": "リビア",
            "vi": "Libya",
            "pt": "Líbia"
        }
    },
    {
        "icon": "🇱🇮",
        "code": "+423",
        "name": {
            "zh": "列支敦士登",
            "en": "Liechtenstein",
            "es": "Liechtenstein",
            "ja": "リヒテンシュタイン",
            "vi": "Liechtenstein",
            "pt": "Liechtenstein"
        }
    },
    {
        "code": "+370",
        "icon": "🇱🇹",
        "name": {
            "zh": "立陶宛",
            "en": "Lithuania",
            "es": "Lituania",
            "ja": "リトアニア",
            "vi": "Litva",
            "pt": "Lituânia"
        }
    },
    {
        "code": "+352",
        "icon": "🇱🇺",
        "name": {
            "zh": "卢森堡",
            "en": "Luxembourg",
            "es": "Luxemburgo",
            "ja": "ルクセンブルク",
            "vi": "Luxembourg",
            "pt": "Luxemburgo"
        }
    },
    {
        "code": "+389",
        "icon": "🇲🇰",
        "name": {
            "zh": "北马其顿",  
            "en": "North Macedonia",
            "es": "Macedonia del Norte",
            "ja": "北マケドニア",
            "vi": "Bắc Macedonia",
            "pt": "Macedônia do Norte"
        }
    },
    {
        "code": "+261",
        "icon": "🇲🇬",
        "name": {
            "zh": "马达加斯加",
            "en": "Madagascar",
            "es": "Madagascar",
            "ja": "マダガスカル",
            "vi": "Madagascar",
            "pt": "Madagáscar"
        }
    },
    {
        "code": "+265",
        "icon": "🇲🇼",
        "name": {
            "zh": "马拉维",
            "en": "Malawi",
            "es": "Malaui",
            "ja": "マラウイ",
            "vi": "Malawi",
            "pt": "Malawi"
        }
    },
    {
        "code": "+60",
        "icon": "🇲🇾",
        "name": {
            "zh": "马来西亚",
            "en": "Malaysia",
            "es": "Malasia",
            "ja": "マレーシア",
            "vi": "Malaysia",
            "pt": "Malásia"
        }
    },
    {
        "code": "+960",
        "icon": "🇲🇻",
        "name": {
            "zh": "马尔代夫",
            "en": "Maldives",
            "es": "Maldivas",
            "ja": "モルディブ",
            "vi": "Maldives",
            "pt": "Maldivas"
        }
    },
    {
        "code": "+223",
        "icon": "🇲🇱",
        "name": {
            "zh": "马里",
            "en": "Mali",
            "es": "Malí",
            "ja": "マリ",
            "vi": "Mali",
            "pt": "Mali"
        }
    },
    {
        "code": "+356",
        "icon": "🇲🇹",
        "name": {
            "zh": "马耳他",
            "en": "Malta",
            "es": "Malta",
            "ja": "マルタ",
            "vi": "Malta",
            "pt": "Malta"
        }
    },
    {
        "code": "+596",
        "icon": "🇲🇶",
        "name": {
            "zh": "马提尼克",
            "en": "Martinique",
            "es": "Martinica",
            "ja": "マルティニーク",
            "vi": "Martinique",
            "pt": "Martinica",
        }
    },
    {
        "code": "+222",
        "icon": "🇲🇷",
        "name": {
            "zh": "毛里塔尼亚",
            "en": "Mauritania",
            "es": "Mauritania",
            "ja": "モーリタニア",
            "vi": "Mauritania",
            "pt": "Mauritânia"
        }
    },
    {
        "code": "+230",
        "icon": "🇲🇺",
        "name": {
            "zh": "毛里求斯",
            "en": "Mauritius",
            "es": "Mauricio",
            "ja": "モーリシャス",
            "vi": "Mauritius",
            "pt": "Maurício"
        }
    },
    {
        "code": "+262",
        "icon": "🇾🇹",
        "name": {
            "zh": "马约特",
            "en": "Mayotte",
            "es": "Mayotte",
            "ja": "マヨット",
            "vi": "Mayotte",
            "pt": "Mayotte",
        }
    },
    {
        "code": "+52",
        "icon": "🇲🇽",
        "name": {
            "zh": "墨西哥",
            "en": "Mexico",
            "es": "México",
            "ja": "メキシコ",
            "vi": "Mexico",
            "pt": "México"
        }
    },
    {
        "code": "+373",
        "icon": "🇲🇩",
        "name": {
            "zh": "摩尔多瓦",
            "en": "Moldova",
            "es": "Moldavia",
            "ja": "モルドバ",
            "vi": "Moldova",
            "pt": "Moldávia"
        }
    },
    {
        "code": "+377",
        "icon": "🇲🇨",
        "name": {
            "zh": "摩纳哥",
            "en": "Monaco",
            "es": "Mónaco",
            "ja": "モナコ",
            "vi": "Monaco",
            "pt": "Mónaco"
        }
    },
    {
        "code": "+976",
        "icon": "🇲🇳",
        "name": {
            "zh": "蒙古",
            "en": "Mongolia",
            "es": "Mongolia",
            "ja": "モンゴル",
            "vi": "Mông Cổ",
            "pt": "Mongólia"
        }
    },
    {
        "code": "+382",
        "icon": "🇲🇪",
        "name": {
            "zh": "黑山",
            "en": "Montenegro",
            "es": "Montenegro",
            "ja": "モンテネグロ",
            "vi": "Montenegro",
            "pt": "Montenegro"
        }
    },
    {
        "code": "+1664",
        "icon": "🇲🇸",
        "name": {
            "zh": "蒙特塞拉特",
            "en": "Montserrat",
            "es": "Montserrat",
            "ja": "モントセラト",
            "vi": "Montserrat",
            "pt": "Monserrate",
        }
    },
    {
        "code": "+212",
        "icon": "🇲🇦",
        "name": {
            "zh": "摩洛哥",
            "en": "Morocco",
            "es": "Marruecos",
            "ja": "モロッコ",
            "vi": "Maroc",
            "pt": "Marrocos"
        }
    },
    {
        "icon": "🇲🇿",
        "code": "+258",
        "name": {
            "zh": "莫桑比克",
            "en": "Mozambique",
            "es": "Mozambique",
            "ja": "モザンビーク",
            "vi": "Moçambique",
            "pt": "Moçambique"
        }
    }

    ,
    {
        "code": "+264",
        "icon": "🇳🇦",
        "name": {
            "zh": "纳米比亚",
            "en": "Namibia",
            "es": "Namibia",
            "ja": "ナミビア",
            "vi": "Namibia",
            "pt": "Namíbia"
        }
    },
    {
        "code": "+977",
        "icon": "🇳🇵",
        "name": {
            "zh": "尼泊尔",
            "en": "Nepal",
            "es": "Nepal",
            "ja": "ネパール",
            "vi": "Nepal",
            "pt": "Nepal"
        }
    },
    {
        "code": "+31",
        "icon": "🇳🇱",
        "name": {
            "zh": "荷兰",
            "en": "Netherlands",
            "es": "Países Bajos",
            "ja": "オランダ",
            "vi": "Hà Lan",
            "pt": "Países Baixos"
        }
    },
    {
        "icon": "🇧🇶",
        "code": "+599",
        "name": {
            "zh": "荷属加勒比区",
            "en": "Caribbean Netherlands",
            "es": "Caribe Neerlandés",
            "ja": "オランダ領カリブ",
            "vi": "Caribe Hà Lan",
            "pt": "Caribe Neerlandês",
        }
    },
    {
        "code": "+687",
        "icon": "🇳🇨",
        "name": {
            "zh": "新喀里多尼亚",
            "en": "New Caledonia",
            "es": "Nueva Caledonia",
            "ja": "ニューカレドニア",
            "vi": "Nouvelle-Calédonie",
            "pt": "Nova Caledônia",
        }
    },
    {
        "code": "+64",
        "icon": "🇳🇿",
        "name": {
            "zh": "新西兰",
            "en": "New Zealand",
            "es": "Nueva Zelanda",
            "ja": "ニュージーランド",
            "vi": "New Zealand",
            "pt": "Nova Zelândia"
        }
    },
    {
        "code": "+505",
        "icon": "🇳🇮",
        "name": {
            "zh": "尼加拉瓜",
            "en": "Nicaragua",
            "es": "Nicaragua",
            "ja": "ニカラグア",
            "vi": "Nicaragua",
            "pt": "Nicarágua"
        }
    }

    ,
    {
        "code": "+227",
        "icon": "🇳🇪",
        "name": {
            "zh": "尼日尔",
            "en": "Niger",
            "es": "Níger",
            "ja": "ニジェール",
            "vi": "Niger",
            "pt": "Níger"
        }
    },
    {
        "code": "+234",
        "icon": "🇳🇬",
        "name": {
            "zh": "尼日利亚",
            "en": "Nigeria",
            "es": "Nigeria",
            "ja": "ナイジェリア",
            "vi": "Nigeria",
            "pt": "Nigéria"
        }
    },
    {
        "code": "+47",
        "icon": "🇳🇴",
        "name": {
            "zh": "挪威",
            "en": "Norway",
            "es": "Noruega",
            "ja": "ノルウェー",
            "vi": "Na Uy",
            "pt": "Noruega"
        }
    },
    {
        "code": "+968",
        "icon": "🇴🇲",
        "name": {
            "zh": "阿曼",
            "en": "Oman",
            "es": "Omán",
            "ja": "オマーン",
            "vi": "Oman",
            "pt": "Omã"
        }
    },
    {
        "code": "+92",
        "icon": "🇵🇰",
        "name": {
            "zh": "巴基斯坦",
            "en": "Pakistan",
            "es": "Pakistán",
            "ja": "パキスタン",
            "vi": "Pakistan",
            "pt": "Paquistão"
        }
    },
    {
        "code": "+970",
        "icon": "🇵🇸",
        "name": {
            "zh": "巴勒斯坦",
            "en": "Palestine",
            "es": "Palestina",
            "ja": "パレスチナ",
            "vi": "Palestine",
            "pt": "Palestina",
        }
    },
    {
        "code": "+507",
        "icon": "🇵🇦",
        "name": {
            "zh": "巴拿马",
            "en": "Panama",
            "es": "Panamá",
            "ja": "パナマ",
            "vi": "Panama",
            "pt": "Panamá"
        }
    }

    ,
    {
        "code": "+675",
        "icon": "🇵🇬",
        "name": {
            "zh": "巴布亚新几内亚",
            "en": "Papua New Guinea",
            "es": "Papúa Nueva Guinea",
            "ja": "パプアニューギニア",
            "vi": "Papua New Guinea",
            "pt": "Papua-Nova Guiné"
        }
    },
    {
        "code": "+595",
        "icon": "🇵🇾",
        "name": {
            "zh": "巴拉圭",
            "en": "Paraguay",
            "es": "Paraguay",
            "ja": "パラグアイ",
            "vi": "Paraguay",
            "pt": "Paraguai"
        }
    },
    {
        "code": "+51",
        "icon": "🇵🇪",
        "name": {
            "zh": "秘鲁",
            "en": "Peru",
            "es": "Perú",
            "ja": "ペルー",
            "vi": "Peru",
            "pt": "Peru"
        }
    },
    {
        "code": "+63",
        "icon": "🇵🇭",
        "name": {
            "zh": "菲律宾",
            "en": "Philippines",
            "es": "Filipinas",
            "ja": "フィリピン",
            "vi": "Philippines",
            "pt": "Filipinas"
        }
    },
    {
        "code": "+48",
        "icon": "🇵🇱",
        "name": {
            "zh": "波兰",
            "en": "Poland",
            "es": "Polonia",
            "ja": "ポーランド",
            "vi": "Ba Lan",
            "pt": "Polônia"
        }
    },
    {
        "code": "+351",
        "icon": "🇵🇹",
        "name": {
            "zh": "葡萄牙",
            "en": "Portugal",
            "es": "Portugal",
            "ja": "ポルトガル",
            "vi": "Bồ Đào Nha",
            "pt": "Portugal"
        }
    },
    {
        "code": "+1",
        "icon": "🇵🇷",
        "name": {
            "zh": "波多黎各",
            "en": "Puerto Rico",
            "es": "Puerto Rico",
            "ja": "プエルトリコ",
            "vi": "Puerto Rico",
            "pt": "Porto Rico",
        }
    },
    {
        "code": "+974",
        "icon": "🇶🇦",
        "name": {
            "zh": "卡塔尔",
            "en": "Qatar",
            "es": "Catar",
            "ja": "カタール",
            "vi": "Qatar",
            "pt": "Catar"
        }
    }

    ,
    {
        "code": "+262",
        "icon": "🇷🇪",
        "name": {
            "zh": "留尼汪",
            "en": "Réunion",
            "es": "Reunión",
            "ja": "レユニオン",
            "vi": "Réunion",
            "pt": "Reunião",
        }
    },
    {
        "code": "+40",
        "icon": "🇷🇴",
        "name": {
            "zh": "罗马尼亚",
            "en": "Romania",
            "es": "Rumania",
            "ja": "ルーマニア",
            "vi": "Romania",
            "pt": "Romênia"
        }
    },
    {
        "code": "+7",
        "icon": "🇷🇺",
        "name": {
            "zh": "俄罗斯",
            "en": "Russia",
            "es": "Rusia",
            "ja": "ロシア",
            "vi": "Nga",
            "pt": "Rússia",
        }
    },
    {
        "code": "+250",
        "icon": "🇷🇼",
        "name": {
            "zh": "卢旺达",
            "en": "Rwanda",
            "es": "Ruanda",
            "ja": "ルワンダ",
            "vi": "Rwanda",
            "pt": "Ruanda"
        }
    },
    {
        "code": "+684",
        "icon": "🇦🇸",
        "name": {
            "zh": "美属萨摩亚",
            "en": "American Samoa",
            "es": "Samoa Americana",
            "ja": "アメリカ領サモア",
            "vi": "Samoa thuộc Mỹ",
            "pt": "Samoa Americana",
        }
    },
    {
        "code": "+685",
        "icon": "🇼🇸",
        "name": {
            "zh": "萨摩亚",
            "en": "Samoa",
            "es": "Samoa",
            "ja": "サモア",
            "vi": "Samoa",
            "pt": "Samoa"
        }
    },
    {
        "code": "+378",
        "icon": "🇸🇲",
        "name": {
            "zh": "圣马力诺",
            "en": "San Marino",
            "es": "San Marino",
            "ja": "サンマリノ",
            "vi": "San Marino",
            "pt": "São Marinho"
        }
    },
    {
        "code": "+239",
        "icon": "🇸🇹",
        "name": {
            "zh": "圣多美和普林西比",
            "en": "São Tomé and Príncipe",
            "es": "Santo Tomé y Príncipe",
            "ja": "サントメ・プリンシペ",
            "vi": "São Tomé và Príncipe",
            "pt": "São Tomé e Príncipe"
        }
    },
    {
        "code": "+966",
        "icon": "🇸🇦",
        "name": {
            "zh": "沙特阿拉伯",
            "en": "Saudi Arabia",
            "es": "Arabia Saudita",
            "ja": "サウジアラビア",
            "vi": "Ả Rập Xê Út",
            "pt": "Arábia Saudita"
        }
    }

    ,
    {
        "code": "+221",
        "icon": "🇸🇳",
        "name": {
            "zh": "塞内加尔",
            "en": "Senegal",
            "es": "Senegal",
            "ja": "セネガル",
            "vi": "Sénégal",
            "pt": "Senegal"
        }
    },
    {
        "icon": "🇷🇸",
        "code": "+381",
        "name": {
            "zh": "塞尔维亚",
            "en": "Serbia",
            "es": "Serbia",
            "ja": "セルビア",
            "vi": "Serbia",
            "pt": "Sérvia"
        }
    },
    {
        "icon": "🇸🇨",
        "code": "+248",
        "name": {
            "zh": "塞舌尔",
            "en": "Seychelles",
            "es": "Seychelles",
            "ja": "セーシェル",
            "vi": "Seychelles",
            "pt": "Seicheles"
        }
    },
    {
        "icon": "🇸🇱",
        "code": "+232",
        "name": {
            "zh": "塞拉利昂",
            "en": "Sierra Leone",
            "es": "Sierra Leona",
            "ja": "シエラレオネ",
            "vi": "Sierra Leone",
            "pt": "Serra Leoa"
        }
    },
    {
        "icon": "🇸🇰",
        "code": "+421",
        "name": {
            "zh": "斯洛伐克",
            "en": "Slovakia",
            "es": "Eslovaquia",
            "ja": "スロバキア",
            "vi": "Slovakia",
            "pt": "Eslováquia"
        }
    },
    {
        "icon": "🇸🇮",
        "code": "+386",
        "name": {
            "zh": "斯洛文尼亚",
            "en": "Slovenia",
            "es": "Eslovenia",
            "ja": "スロベニア",
            "vi": "Slovenia",
            "pt": "Eslovênia"
        }
    },
    {
        "icon": "🇿🇦",
        "code": "+27",
        "name": {
            "zh": "南非",
            "en": "South Africa",
            "es": "Sudáfrica",
            "ja": "南アフリカ",
            "vi": "Nam Phi",
            "pt": "África do Sul"
        }
    },
    {
        "code": "+82",
        "icon": "🇰🇷",
        "name": {
            "zh": "韩国",
            "en": "South Korea",
            "es": "Corea del Sur",
            "ja": "韓国",
            "vi": "Hàn Quốc",
            "pt": "Coreia do Sul"
        }
    },
    {
        "code": "+34",
        "icon": "🇪🇸",
        "name": {
            "zh": "西班牙",
            "en": "Spain",
            "es": "España",
            "ja": "スペイン",
            "vi": "Tây Ban Nha",
            "pt": "Espanha"
        }
    },
    {
        "icon": "🇱🇰",
        "code": "+94",
        "name": {
            "zh": "斯里兰卡",
            "en": "Sri Lanka",
            "es": "Sri Lanka",
            "ja": "スリランカ",
            "vi": "Sri Lanka",
            "pt": "Sri Lanka"
        }
    },
    {
        "icon": "🇰🇳",
        "code": "+1869",
        "name": {
            "zh": "圣基茨和尼维斯",
            "en": "Saint Kitts and Nevis",
            "es": "San Cristóbal y Nieves",
            "ja": "セントクリストファー・ネイビス",
            "vi": "Saint Kitts và Nevis",
            "pt": "São Cristóvão e Nevis"
        }
    },
    {
        "icon": "🇱🇨",
        "code": "+1758",
        "name": {
            "zh": "圣卢西亚",
            "en": "Saint Lucia",
            "es": "Santa Lucía",
            "ja": "セントルシア",
            "vi": "Saint Lucia",
            "pt": "Santa Lúcia"
        }
    }

    ,
    {
        "icon": "🇻🇨",
        "code": "+1784",
        "name": {
            "zh": "圣文森特和格林纳丁斯",
            "en": "Saint Vincent and the Grenadines",
            "es": "San Vicente y las Granadinas",
            "ja": "セントビンセント・グレナディーン",
            "vi": "Saint Vincent và Grenadines",
            "pt": "São Vicente e Granadinas"
        }
    },
    {
        "icon": "🇸🇩",
        "code": "+249",
        "name": {
            "zh": "苏丹",
            "en": "Sudan",
            "es": "Sudán",
            "ja": "スーダン",
            "vi": "Sudan",
            "pt": "Sudão"
        }
    },
    {
        "icon": "🇸🇷",
        "code": "+597",
        "name": {
            "zh": "苏里南",
            "en": "Suriname",
            "es": "Surinam",
            "ja": "スリナム",
            "vi": "Suriname",
            "pt": "Suriname"
        }
    },
    {
        "icon": "🇸🇿",
        "code": "+268",
        "name": {
            "zh": "斯威士兰",
            "en": "Eswatini",
            "es": "Esuatini",
            "ja": "エスワティニ",
            "vi": "Eswatini",
            "pt": "Essuatíni"
        }
    },
    {
        "code": "+46",
        "icon": "🇸🇪",
        "name": {
            "zh": "瑞典",
            "en": "Sweden",
            "es": "Suecia",
            "ja": "スウェーデン",
            "vi": "Thụy Điển",
            "pt": "Suécia"
        }
    },
    {
        "code": "+41",
        "icon": "🇨🇭",
        "name": {
            "zh": "瑞士",
            "en": "Switzerland",
            "es": "Suiza",
            "ja": "スイス",
            "vi": "Thụy Sĩ",
            "pt": "Suíça"
        }
    },
    {
        "icon": "🇸🇾",
        "code": "+963",
        "name": {
            "zh": "叙利亚",
            "en": "Syria",
            "es": "Siria",
            "ja": "シリア",
            "vi": "Syria",
            "pt": "Síria"
        }
    },
    {
        "icon": "🇹🇯",
        "code": "+992",
        "name": {
            "zh": "塔吉克斯坦",
            "en": "Tajikistan",
            "es": "Tayikistán",
            "ja": "タジキスタン",
            "vi": "Tajikistan",
            "pt": "Tajiquistão"
        }
    },
    {
        "icon": "🇹🇿",
        "code": "+255",
        "name": {
            "zh": "坦桑尼亚",
            "en": "Tanzania",
            "es": "Tanzania",
            "ja": "タンザニア",
            "vi": "Tanzania",
            "pt": "Tanzânia"
        }
    },
    {
        "icon": "🇹🇭",
        "code": "+66",
        "name": {
            "zh": "泰国",
            "en": "Thailand",
            "es": "Tailandia",
            "ja": "タイ",
            "vi": "Thái Lan",
            "pt": "Tailândia"
        }
    },
    {
        "icon": "🇹🇱",
        "code": "+670",
        "name": {
            "zh": "东帝汶",
            "en": "Timor-Leste",
            "es": "Timor Oriental",
            "ja": "東ティモール",
            "vi": "Timor-Leste",
            "pt": "Timor-Leste"
        }
    },
    {
        "icon": "🇹🇬",
        "code": "+228",
        "name": {
            "zh": "多哥",
            "en": "Togo",
            "es": "Togo",
            "ja": "トーゴ",
            "vi": "Togo",
            "pt": "Togo"
        }
    },
    {
        "icon": "🇹🇴",
        "code": "+676",
        "name": {
            "zh": "汤加",
            "en": "Tonga",
            "es": "Tonga",
            "ja": "トンガ",
            "vi": "Tonga",
            "pt": "Tonga"
        }
    },
    {
        "icon": "🇹🇹",
        "code": "+1868",
        "name": {
            "zh": "特立尼达和多巴哥",
            "en": "Trinidad and Tobago",
            "es": "Trinidad y Tobago",
            "ja": "トリニダード・トバゴ",
            "vi": "Trinidad và Tobago",
            "pt": "Trinidad e Tobago"
        }
    },
    {
        "icon": "🇹🇳",
        "code": "+216",
        "name": {
            "zh": "突尼斯",
            "en": "Tunisia",
            "es": "Túnez",
            "ja": "チュニジア",
            "vi": "Tunisia",
            "pt": "Tunísia"
        }
    },
    {
        "icon": "🇹🇷",
        "code": "+90",
        "name": {
            "zh": "土耳其",
            "en": "Türkiye",
            "es": "Turquía",
            "ja": "トルコ",
            "vi": "Thổ Nhĩ Kỳ",
            "pt": "Turquia"
        }
    },
    {
        "icon": "🇹🇲",
        "code": "+993",
        "name": {
            "zh": "土库曼斯坦",
            "en": "Turkmenistan",
            "es": "Turkmenistán",
            "ja": "トルクメニスタン",
            "vi": "Turkmenistan",
            "pt": "Turcomenistão"
        }
    },
    {
        "icon": "🇹🇨",
        "code": "+1649",
        "name": {
            "zh": "特克斯和凯科斯群岛",
            "en": "Turks and Caicos Islands",
            "es": "Islas Turcas y Caicos",
            "ja": "タークス・カイコス諸島",
            "vi": "Quần đảo Turks và Caicos",
            "pt": "Ilhas Turcas e Caicos",

        }
    },
    {
        "icon": "🇺🇬",
        "code": "+256",
        "name": {
            "zh": "乌干达",
            "en": "Uganda",
            "es": "Uganda",
            "ja": "ウガンダ",
            "vi": "Uganda",
            "pt": "Uganda"
        }
    },
    {
        "icon": "🇺🇦",
        "code": "+380",
        "name": {
            "zh": "乌克兰",
            "en": "Ukraine",
            "es": "Ucrania",
            "ja": "ウクライナ",
            "vi": "Ukraina",
            "pt": "Ucrânia"
        }
    },
    {
        "icon": "🇦🇪",
        "code": "+971",
        "name": {
            "zh": "阿拉伯联合酋长国",
            "en": "United Arab Emirates",
            "es": "Emiratos Árabes Unidos",
            "ja": "アラブ首長国連邦",
            "vi": "Các Tiểu Vương quốc Ả Rập Thống nhất",
            "pt": "Emirados Árabes Unidos"
        }
    },
    {
        "code": "+44",
        "icon": "🇬🇧",
        "name": {
            "zh": "英国",
            "en": "United Kingdom",
            "es": "Reino Unido",
            "ja": "イギリス",
            "vi": "Vương quốc Anh",
            "pt": "Reino Unido"
        }
    },
    {
        "icon": "🇺🇸",
        "code": "+1",
        "name": {
            "zh": "美国",
            "en": "United States",
            "es": "Estados Unidos",
            "ja": "アメリカ合衆国",
            "vi": "Hoa Kỳ",
            "pt": "Estados Unidos"
        }
    },
    {
        "icon": "🇺🇾",
        "code": "+598",
        "name": {
            "zh": "乌拉圭",
            "en": "Uruguay",
            "es": "Uruguay",
            "ja": "ウルグアイ",
            "vi": "Uruguay",
            "pt": "Uruguai"
        }
    },
    {
        "icon": "🇺🇿",
        "code": "+998",
        "name": {
            "zh": "乌兹别克斯坦",
            "en": "Uzbekistan",
            "es": "Uzbekistán",
            "ja": "ウズベキスタン",
            "vi": "Uzbekistan",
            "pt": "Uzbequistão"
        }
    },
    {
        "icon": "🇻🇺",
        "code": "+678",
        "name": {
            "zh": "瓦努阿图",
            "en": "Vanuatu",
            "es": "Vanuatu",
            "ja": "バヌアツ",
            "vi": "Vanuatu",
            "pt": "Vanuatu"
        }
    },
    {
        "icon": "🇻🇪",
        "code": "+58",
        "name": {
            "zh": "委内瑞拉",
            "en": "Venezuela",
            "es": "Venezuela",
            "ja": "ベネズエラ",
            "vi": "Venezuela",
            "pt": "Venezuela"
        }
    },
    {
        "icon": "🇻🇳",
        "code": "+84",
        "name": {
            "zh": "越南",
            "en": "Vietnam",
            "es": "Vietnam",
            "ja": "ベトナム",
            "vi": "Việt Nam",
            "pt": "Vietnã"
        }
    },
    {
        "icon": "🇻🇮",
        "code": "+1340",
        "name": {
            "zh": "美属维尔京群岛",
            "en": "U.S. Virgin Islands",
            "es": "Islas Vírgenes de EE.UU.",
            "ja": "アメリカ領ヴァージン諸島",
            "vi": "Quần đảo Virgin thuộc Mỹ",
            "pt": "Ilhas Virgens Americanas",
        }
    },
    {
        "icon": "🇾🇪",
        "code": "+967",
        "name": {
            "zh": "也门",
            "en": "Yemen",
            "es": "Yemen",
            "ja": "イエメン",
            "vi": "Yemen",
            "pt": "Iêmen"
        }
    },
    {
        "icon": "🇿🇲",
        "code": "+260",
        "name": {
            "zh": "赞比亚",
            "en": "Zambia",
            "es": "Zambia",
            "ja": "ザンビア",
            "vi": "Zambia",
            "pt": "Zâmbia"
        }
    },
    {
        "icon": "🇿🇼",
        "code": "+263",
        "name": {
            "zh": "津巴布韦",
            "en": "Zimbabwe",
            "es": "Zimbabue",
            "ja": "ジンバブエ",
            "vi": "Zimbabwe",
            "pt": "Zimbábue"
        }
    }

]